<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

* {
  margin: 0px;
  padding: 0px;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 4vmin;
  font-weight: normal;
}

.bgImg {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  image-rendering: -webkit-optimize-contrast;
  position: absolute;
  padding: 0px;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
}

@keyframes playframes {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}

@keyframes nameRoll-15 {0% {left: 0;}100% {left: -18vw;}}
@keyframes nameRoll-16 {0% {left: 0;}100% {left: -24vw;}}
@keyframes nameRoll-17 {0% {left: 0;}100% {left: -30vw;}}
@keyframes nameRoll-18 {0% {left: 0;}100% {left: -36vw;}}
@keyframes nameRoll-19 {0% {left: 0;}100% {left: -42vw;}}
@keyframes nameRoll-20 {0% {left: 0;}100% {left: -48vw;}}
@keyframes nameRoll-21 {0% {left: 0;}100% {left: -54vw;}}
@keyframes nameRoll-22 {0% {left: 0;}100% {left: -60vw;}}
@keyframes nameRoll-23 {0% {left: 0;}100% {left: -66vw;}}
@keyframes nameRoll-24 {0% {left: 0;}100% {left: -72vw;}}
@keyframes nameRoll-25 {0% {left: 0;}100% {left: -78vw;}}
@keyframes nameRoll-26 {0% {left: 0;}100% {left: -84vw;}}
@keyframes nameRoll-27 {0% {left: 0;}100% {left: -90vw;}}
@keyframes nameRoll-28 {0% {left: 0;}100% {left: -96vw;}}
@keyframes nameRoll-29 {0% {left: 0;}100% {left: -102vw;}}
@keyframes nameRoll-30 {0% {left: 0;}100% {left: -108vw;}}
@keyframes nameRoll-31 {0% {left: 0;}100% {left: -114vw;}}
@keyframes nameRoll-32 {0% {left: 0;}100% {left: -120vw;}}
@keyframes nameRoll-33 {0% {left: 0;}100% {left: -126vw;}}
@keyframes nameRoll-34 {0% {left: 0;}100% {left: -132vw;}}
@keyframes nameRoll-35 {0% {left: 0;}100% {left: -138vw;}}
@keyframes nameRoll-36 {0% {left: 0;}100% {left: -144vw;}}
@keyframes nameRoll-37 {0% {left: 0;}100% {left: -150vw;}}
@keyframes nameRoll-38 {0% {left: 0;}100% {left: -156vw;}}
@keyframes nameRoll-39 {0% {left: 0;}100% {left: -162vw;}}
@keyframes nameRoll-40 {0% {left: 0;}100% {left: -168vw;}}
@keyframes nameRoll-41 {0% {left: 0;}100% {left: -174vw;}}
@keyframes nameRoll-42 {0% {left: 0;}100% {left: -180vw;}}
@keyframes nameRoll-43 {0% {left: 0;}100% {left: -186vw;}}
@keyframes nameRoll-44 {0% {left: 0;}100% {left: -192vw;}}
@keyframes nameRoll-45 {0% {left: 0;}100% {left: -198vw;}}
@keyframes nameRoll-46 {0% {left: 0;}100% {left: -204vw;}}
@keyframes nameRoll-47 {0% {left: 0;}100% {left: -210vw;}}
@keyframes nameRoll-48 {0% {left: 0;}100% {left: -216vw;}}
@keyframes nameRoll-49 {0% {left: 0;}100% {left: -222vw;}}
@keyframes nameRoll-50 {0% {left: 0;}100% {left: -228vw;}}
@keyframes nameRoll-51 {0% {left: 0;}100% {left: -234vw;}}

</style>



// WEBPACK FOOTER //
// src/App.vue